import {Component, Inject} from '@angular/core';
import {TranslocoDirective} from "@jsverse/transloco";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheet} from "@angular/material/bottom-sheet";
import {ClosableBottomSheetComponent, ClosableBottomSheetHandleComponent, openMapApp} from "shared-lib";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-how-to-redeem-directions',
  imports: [
    TranslocoDirective,
    ClosableBottomSheetHandleComponent,
    MatButton
  ],
  templateUrl: './how-to-redeem-directions.component.html',
  styleUrl: './how-to-redeem-directions.component.scss'
})
export class HowToRedeemDirectionsComponent extends ClosableBottomSheetComponent {

  protected readonly openMapApp = openMapApp;

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: HowToRedeemData,
              bottomSheet: MatBottomSheet) {
    super(bottomSheet)
  }

}

export interface HowToRedeemData {
  rewardAmount: number,
  merchantName: string,
  fullAddress: string | undefined,
  latitude: number,
  longitude: number,
}

